var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"b41134fa1a41871e1df8de82c03455d4eba617cd"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';

import { env } from './src/utils/env.mjs';

Sentry.init({
  tracesSampleRate: 0,
  dsn: env.NEXT_PUBLIC_SENTRY_DSN,
  release: env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
  environment: env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
});
